import React from 'react';
import { Button, Typography } from '@up-riac/bespoke-ui';
import { AuctionDate } from 'src/components/AuctionDate/AuctionDate';
import dayjs from 'dayjs';
import { ActiveAuction } from 'src/lib/GlobalDataContext';

export const MegaMenuAuctionsCard = ({ auction, description, to, buttonLabel, src, onPress }: {
  auction: ActiveAuction,
  description: string,
  to: string,
  buttonLabel: string,
  src: string,
  onPress: () => void,
}): JSX.Element => {
  // object-left is probably temporary until we have better images

  return <div className='flex flex-col gap-3 max-w-[270px]'>
    <img src={src} className='aspect-[270/210] object-cover object-left'/>
    <div className='flex flex-col'>
      <Button
        unstyled
        variant='accent'
        to={to}
        onPress={onPress}
        className={'text-accent hover:underline underline-offset-4'}
      >
        <div className='flex flex-col gap-1'>
          <Typography color={'text-accent'} heading size='xs'>{auction.Title}</Typography>
        </div>
      </Button>
      <Typography size='sm' className='text-neutral-600 italic'><AuctionDate
        omitIcon
        auction = {auction}
        omitTime
      /></Typography>
      <Typography size='sm' className='text-neutral-500 italic'>{description}</Typography>
    </div>
  </div>;
};
